import Image from '@/components/atoms/Image';
import { LineItem } from '@shared/types/cart';
import useMediaQuery from '@/hooks/useMediaQuery';
import { desktop, mediumDesktop } from '@/constants/screensizes';
import { Currency } from '@/types/currency';
import useFormat from '@/hooks/useFormat';
import Link from '@/components/atoms/link';

const ReviewOrderSummaryItem = ({ lineItem }: { lineItem: LineItem }) => {
  const [isDesktop] = useMediaQuery(desktop);
  const [isMediumDesktop] = useMediaQuery(mediumDesktop);
  const { variant, name, productId, price, count, _url, totalPrice, bundleProducts = [] } = lineItem;
  const [primaryImg] = variant?.images ?? [];
  const colour = variant?.attributes?.colour;
  const dimension = isMediumDesktop ? 200 : isDesktop ? 160 : 120;
  const bundleProductExists = bundleProducts?.length > 0;
  const { formatCurrency } = useFormat();

  if (isDesktop) {
    return (
      <>
        <div className="mt-6 lg:mb-5 lg:flex">
          <div>
            <Link link={_url ?? '#'} className={`lg:!w-[160px] block`}>
              {' '}
              <Image
                style={{ height: "160px", width: "160px", backgroundSize: 'cover' }}
                height={160}
                width={160}
                className='block'
                alt={name as string}
                src={primaryImg || '/images/No_product_Image.jpg'}
              />
            </Link>
          </div>

          <div className="lg:flex lg:w-full lg:justify-between ">
            <div className="flex flex-col gap-2 lg:ml-8">
              <Link link={_url ?? '#'}>
                <h4 className="mb-[4px] text-20 max-w-[230px] font-semibold">{name || 'product name'}</h4>
              </Link>
              {bundleProductExists && (
                <div className="mb-1 mt-1 flex flex-col gap-[6px]">
                  <Link link={_url ?? '#'}>
                    {' '}
                    {bundleProducts?.map((bundleProduct) => {
                      return <p className="text-[17px] leading-[1.375rem]">{bundleProduct.name}</p>;
                    })}
                  </Link>
                </div>
              )}
              {!lineItem.isBrochure && (
                <Link link={_url ?? '#'}>
                  <p
                    className={`text-18 !font-light ${bundleProductExists ? 'mt-1' : ''}`}
                  >{`Product Code: ${productId}`}</p>
                </Link>
              )}
              <p className="text-18 !font-semibold">{`Price per unit: ${formatCurrency(
                (price?.centAmount as number) / 100,
                price?.currencyCode as Currency,
              )} `}</p>
              <div className="">
                <span className="text-18 !font-light text-[#828282]">QTY</span>
                <span className="ml-4 text-18 font-medium">{count}</span>
              </div>
            </div>
            <div className="flex flex-col items-end">
              <p className="text-24 font-semibold">
                {formatCurrency((totalPrice?.centAmount as number) / 100, totalPrice?.currencyCode as Currency)}
              </p>
              <p className="text-18 !font-light">ex. GST</p>
            </div>
          </div>
        </div>
        <hr className='mt-8 border-t-2 border-[#D3D3D3]' />
      </>
    );
  }
  return (
    <>
      <div className="mt-6 lg:mb-5 lg:flex">
        <div className="flex w-full gap-5">
          <div>
            <Link link={_url ?? '#'} className={` !block !w-[120px]`}>
              <Image
                style={{ height: dimension, width: dimension, backgroundSize: 'cover' }}
                height={dimension}
                width={dimension}
                alt={name as string}
                src={primaryImg || '/images/No_product_Image.jpg'}
              /></Link>
          </div>
          <div className="flex flex-col gap-4">
            <Link link={_url ?? '#'}>
              <h4 className={`text-17 font-semibold ${bundleProductExists ? 'mb-1' : ''} md:text-20`}>
                {name || 'product name'}
              </h4>
            </Link>
            <Link link={_url ?? '#'}>
              {bundleProductExists && (
                <div>
                  {bundleProducts?.map((bundleProduct) => {
                    return <p className="text-[17px] leading-[1.375rem]">{bundleProduct.name}</p>;
                  })}
                </div>
              )}
            </Link>
            <Link link={_url ?? '#'}>
              <p className={`text-[15.5px] ${bundleProductExists ? 'mt-2' : ''}`}>{`${productId}`}</p></Link>
          </div>
        </div>

        <div className="lg:flex lg:w-full lg:justify-between">
          <p className="mt-5 text-[15.5px] font-medium">{`Price per unit: ${formatCurrency((price?.centAmount as number / 100), price?.currencyCode as Currency)}`}</p>
          {!isDesktop && colour && (
            <div className="mt-2 flex gap-2">
              <p className="text-[15.5px] font-medium text-[#828282]">{`Colour: `}</p>
              <p className="text-[15.5px] font-medium">{colour}</p>
            </div>
          )}
          <div className="mt-2">
            <span className="text-[15.5px] font-light text-[#828282]">QTY</span>
            <span className="ml-4 text-[15.5px] font-medium">{count}</span>
          </div>
          <div className='w-full flex justify-end' >
            <div className="grid grid-cols-2 gap-[24px] lg:gap-[60px] w-[280px] sm:w-[350px] mx-4">
              <p className='font-medium mt-1 text-[15.5px] md:text-18 text-end'>Price</p>
              <p className='font-semibold text-20 md:text-24 text-end whitespace-nowrap'>
                {formatCurrency((totalPrice?.centAmount as number / 100), totalPrice?.currencyCode as Currency)}
              </p>
            </div>

          </div>
        </div>
      </div>
      <hr className='mt-8 border-t-2 border-[#D3D3D3]' />
    </>
  );
};

export default ReviewOrderSummaryItem;
